const STATS = [
  { value: "17+", label: "Años de práctica profesional continua" },
  { value: "200+", label: "Empresas familiares asesoradas" },
  { value: "2", label: "Oficinas: Guadalajara y CDMX" },
  { value: "9", label: "Herramientas en Plataforma RP" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-12 sm:py-16 bg-white border-y border-slate-100">
      <div className="rp-container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {STATS.map((s, i) => (
            <div
              key={i}
              className="rp-reveal text-center lg:text-left"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`stat-${i}`}
            >
              <div
                className="text-5xl sm:text-6xl font-extrabold rp-gradient-text leading-none"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                {s.value}
              </div>
              <div className="mt-3 text-sm text-slate-600 max-w-[200px] mx-auto lg:mx-0">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
